import calls from '@/backend/api-calls'

const state = () => ({
  samples: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    sample_type: 'Project'
  }
})

// getters
const getters = {
  ids: state => {
    return state.samples.map(d => d.id);
  }
}

// actions
const actions = {
  getSamples: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.samples.get(parameters)
        .then(resp => {
          commit("setSamples", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addSample({commit}, data) {
    return new Promise((resolve, reject) => {
      calls.samples.post(data)
        .then(resp => {
          commit("insertSample", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addSampleImage({commit}, { sampleId, data }) {
    return new Promise((resolve, reject) => {
      calls.sample.addImage(sampleId, data)
        .then(resp => {
          commit("insertUpdatedSample", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateSample: ({commit}, { sampleId, data }) => {
    return new Promise((resolve, reject) => {
      calls.sample.put(sampleId, data).then(
        resp => {
          commit("insertUpdatedSample", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Sample successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteSample: ({commit}, sampleId) => {
    return new Promise((resolve, reject) => {
      calls.sample.delete(sampleId).then(
        resp => {
          commit("removeSample", sampleId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Sample successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  // addDetail: ({commit}, detail) => {
  //   return new Promise((resolve, reject) => {
  //     calls.orderDetails.post(detail).then(
  //       resp => {
  //         commit("insertOrderDetail", resp.data);
  //         resolve(resp);
  //       }
  //     ).catch(err => reject(err));
  //   })
  // },
  // addBomDetail: ({commit}, detail) => {
  //   return new Promise((resolve, reject) => {
  //     calls.orderDetailsBoms.post(detail).then(
  //       resp => {
  //         commit("insertOrderDetail", resp.data);
  //         resolve(resp);
  //       }
  //     ).catch(err => reject(err));
  //   })
  // },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setSamples(state, data) {
    state.pagination = data.pagination;
    state.samples = data.results;
  },
  insertSample(state, data) {
    state.samples.push(data);
  },
  insertUpdatedSample(state, data) {
    state.samples.forEach((sample, i) => {
      if (sample.id == data.id) {
        state.samples.splice(i, 1, data);
      }
    })
  },
  removeSample(state, sampleId) {
    state.samples.forEach((sample, i) => {
      if (sample.id == sampleId) {
        state.samples.splice(i, 1);
      }
      const index = state.selected.indexOf(sampleId);
      if (index != -1) {
        state.selected.splice(index, 1);
      }
    })
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  // insertOrderDetail(state, orderDetail) {
  //   state.orders.forEach(order => {
  //     if (order.id == orderDetail.order_id) {
  //       order.details.push(orderDetail);
  //     }
  //   })
  // },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}